import { getApolloClient } from './get-apollo-client';
import { getToken, recoverFromAuthFailure } from '@coverright/shared/keycloak';
import { InMemoryCacheConfig } from '@apollo/client';
import { environment } from '@coverright/shared/config';
import moment from 'moment/moment';
import { getAgeByBirthdate, getUserName } from '@coverright/utils';

const inMemoryCacheConfig: InMemoryCacheConfig = {
  typePolicies: {
    ClientViewListRepresentationOutput: {
      keyFields: ['clientId']
    },
    ClientViewForAdviserOutput: {
      keyFields: ['clientId']
    },
    AdvisorDetailsOutput: {
      keyFields: ['userId']
    },
    UserProfileOutput: {
      keyFields: ['profileId'],
      fields: {
        birthDate: (existing) => {
          if (existing && /\d{4}-\d{2}-\d{2}/gm.test(existing)) {
            return moment(existing, 'YYYY-MM-DD').format('MM/DD/YYYY');
          }
          return existing;
        },
        age: (existing, { readField }) => {
          return getAgeByBirthdate(readField('birthDate'), 'MM/DD/YYYY');
        },
        fullName: (existing, { readField }) => (
          getUserName({firstName: readField('firstName'), lastName: readField('lastName')})
        ),
      },
    }
  },
};

const { client: enrollmentApolloClient, cache: enrollmentApolloCache, preloadQuery: enrollmentPreloadQuery } = getApolloClient(
  getToken,
  environment.enrollGraphqlUrl,
  inMemoryCacheConfig,
  true,
  recoverFromAuthFailure
);
export { enrollmentApolloClient, enrollmentApolloCache, enrollmentPreloadQuery };

